import { render, staticRenderFns } from "./PagePrint.vue?vue&type=template&id=a22196ce&scoped=true"
import script from "./PagePrint.vue?vue&type=script&lang=js"
export * from "./PagePrint.vue?vue&type=script&lang=js"
import style0 from "./PagePrint.vue?vue&type=style&index=0&id=a22196ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22196ce",
  null
  
)

export default component.exports